import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 49,
  initialSeconds = 42
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-bold font-display text-amber-500" data-id="element-332">
      <TimeUnit value={formatNumber(timeLeft.hours)} label="hs" data-id="element-333" />
      <span className="text-slate-500 pb-6" data-id="element-334">:</span>
      <TimeUnit value={formatNumber(timeLeft.minutes)} label="min" data-id="element-335" />
      <span className="text-slate-500 pb-6" data-id="element-336">:</span>
      <TimeUnit value={formatNumber(timeLeft.seconds)} label="seg" data-id="element-337" />
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-338">
      <div className="bg-slate-900/80 border border-white/10 rounded-lg p-3 min-w-[70px] md:min-w-[90px] text-center shadow-inner" data-id="element-339">
        <motion.span key={value} initial={{
        y: 10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} className="block" data-id="element-340">
          {value}
        </motion.span>
      </div>
      <span className="text-xs text-slate-400 mt-2 uppercase tracking-wider font-sans font-medium" data-id="element-341">
        {label}
      </span>
    </div>;
}